import { DateTime, Duration } from 'luxon';
import { dataSourceType } from 'shared/constants.json';
import { encodeURLValues } from '@/lib/url';

export const dataSourceIcon = (dataSource) => {
  if (dataSource === null) {
    return '';
  }

  switch (dataSource.type) {
    case dataSourceType.sheets:
      return 'sheets';
    case dataSourceType.jira:
      return 'jira';
    case dataSourceType.excel:
      return 'excel';
    case dataSourceType.hubspot:
      return 'hubspot';
    case dataSourceType.asana:
      return 'asana';
    case dataSourceType.salesforce:
      return 'salesforce';
    default:
      return '';
  }
};

export const dataSourceSignInIcon = (dataSource) => {
  if (dataSource === null) {
    return '';
  }

  switch (dataSource.type) {
    case dataSourceType.sheets:
      return 'google-color';
    case dataSourceType.jira:
      return 'jira';
    case dataSourceType.excel:
      return 'excel';
    case dataSourceType.hubspot:
      return 'hubspot';
    case dataSourceType.asana:
      return 'asana';
    case dataSourceType.salesforce:
      return 'salesforce';
    default:
      return '';
  }
};

export const connectUrl = (dataSource) => {
  const params = {
    dataSourceId: dataSource.uid,
    origin: '/#/oauth-redirect',
  };

  const targetParams = { oauthRedirect: `/api/v1/data-source/install?${encodeURLValues(params)}` };
  return `/#/oauth-redirect?${encodeURLValues(targetParams)}`;
};

const refreshTokenTTL = {
  [dataSourceType.excel]: Duration.fromObject({ days: 90 }),
  [dataSourceType.sheets]: Duration.fromObject({ days: 200 }),
  [dataSourceType.asana]: Duration.fromObject({ days: 365 }),
  [dataSourceType.jira]: null, // don't expire
  [dataSourceType.hubspot]: null, // don't expire
  [dataSourceType.salesforce]: null, // don't expire. However, this needs to be configured within salesforce.
};

export const expiresWithin = (dataSource, days) => {
  if (refreshTokenTTL[dataSource.type] === null) {
    return false;
  }

  const expiryDate = DateTime.fromISO(dataSource.refreshTokenCreatedAt).plus(refreshTokenTTL[dataSource.type]);
  return expiryDate < DateTime.local().plus(Duration.fromObject({ days }));
};

export const dataSourceError = ({ salesforceQuery }) => {
  if (salesforceQuery === null) {
    return null;
  }

  return salesforceQuery.error;
};
